import { render, staticRenderFns } from "./FileTemplateName.vue?vue&type=template&id=5a5d8cb8&"
import script from "./FileTemplateName.vue?vue&type=script&lang=js&"
export * from "./FileTemplateName.vue?vue&type=script&lang=js&"
import style0 from "./FileTemplateName.vue?vue&type=style&index=0&id=5a5d8cb8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports